// @flow
import {
  FETCH_WALLET,
  FETCH_WALLET_SUCCESS,
  FETCH_WALLET_ERROR,
  SET_WALLET_AMOUNT,
  LOAD_WALLET,
  LOAD_WALLET_SUCCESS,
  LOAD_WALLET_ERROR,
  RESET_LOAD_WALLET,
  CAPTURE_WALLET_PAYMENT,
  FETCH_WALLET_REFUND_LIST,
  WALLET_REFUND_LIST_SUCCESS,
  WALLET_REFUND_LIST_ERROR,
  PROCESS_WALLET_REFUND,
  WALLET_REFUND_SUCCESS,
  WALLET_REFUND_ERROR,
  POOL_WALLET_LOAD,
  CANCEL_POOL_WALLET_LOAD,
  LOAD_WALLET_UPI,
  PARTIAL_REFUND
} from "./types";
import type { Action } from "./types";
// import type { CartData } from "./types";

export const fetchWallet = (mobile: string): Action => ({
  type: FETCH_WALLET,
  payload: { mobile }
});

export const fetchWalletSuccess = (wallet: any): Action => ({
  type: FETCH_WALLET_SUCCESS,
  payload: wallet
});

export const fetchWalletError = (error: Error): Action => ({
  type: FETCH_WALLET_ERROR,
  payload: error
});

export const setLoadAmount = (amount: number): Action => ({
  type: SET_WALLET_AMOUNT,
  payload: amount
});


export const loadWallet = (mobile: string, amount: number, paymentMethod: any): Action => ({
  type: LOAD_WALLET,
  payload: {mobile, amount, paymentMethod}
});

export const loadWalletSuccess = (): Action => ({
  type: LOAD_WALLET_SUCCESS,
});

export const loadWalletError = (error: Error): Action => ({
  type: LOAD_WALLET_ERROR,
  payload: error
});

export const resetWalletLoad = (): Action => ({
  type: RESET_LOAD_WALLET,
});


export const capturePayment = (mobile: string, amount: number, paymentGateway: string, orderId: string | null, status: string, paymentMethod: any): Action => ({
  type: CAPTURE_WALLET_PAYMENT,
  payload: {mobile, amount, paymentMethod ,orderId, status, paymentGateway}
});

export const fetchWalletRefundData = (mobile: string): Action => ({
  type: FETCH_WALLET_REFUND_LIST,
  payload: {mobile}
});

export const walletRefundListSuccess = (data: {}): Action => ({
  type: WALLET_REFUND_LIST_SUCCESS,
  payload: data,
});

export const walletRefundListError = (error: Error): Action => ({
  type: WALLET_REFUND_LIST_ERROR,
  payload: error
});

export const processWalletRefund = (mobile: string, gateway: string, fingerPrint: string, amount: number): Action => ({
  type: PROCESS_WALLET_REFUND,
  payload: {mobile, amount, gateway, fingerPrint}
});

export const walletRefundSuccess = (): Action => ({
  type: WALLET_REFUND_SUCCESS,
});

export const walletRefundError = (error: Error): Action => ({
  type: WALLET_REFUND_ERROR,
  payload: error
});

export const poolWalletLoad = (payload: {}): Action => ({
  type: POOL_WALLET_LOAD,
  payload
});

export const cancelPoolWalletLoad = (): Action => ({
  type: CANCEL_POOL_WALLET_LOAD,
});

export const upiCollectPayment = (mobile: string, amount: number, paymentMethod: any, imei: string): Action => ({
  type: LOAD_WALLET_UPI,
  payload: {mobile, amount, paymentMethod, imei}
});

export const setPartialRefund = (payload: {[key:string]: string| number}): Action => ({
  type: PARTIAL_REFUND,
  payload
});
